import React from "react";
import classNames from "classnames";
import { FormikProps } from "formik";
import isString from "lodash/isString";

import Size from "shared/enums/Size";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import ReAuthenticateUser from "./reAuthenticateUser";
import { AuthenticationAlertModalType } from "./types";
import { Modal, ModalBody } from "shared/components/modal";
import ButtonGroup from "../button/components/buttonGroup";

function AuthenticationAlertModal({
  primaryButtonVariant = Variant.ERROR,
  secondaryButtonVariant = Variant.PRIMARY,
  primaryButtonIsOutlined = false,
  secondaryButtonIsOutlined = true,
  handleConfirm,
  handleClose,
  ...props
}: AuthenticationAlertModalType) {
  const copies = useCopies();
  const formRef = React.useRef<FormikProps<any>>(null);

  const onConfirmHandler = React.useCallback(
    e => {
      formRef.current?.setTouched({ password: true });
      formRef.current?.isValid && handleConfirm?.(formRef.current?.values);
    },
    [handleConfirm]
  );

  return (
    <Modal size={Size.SMALL} className={classNames("alertModal", props.className)}>
      <ModalBody>
        <div className="alertModal_content">
          {props.title && <h4>{props.title}</h4>}
          {isString(props.message) ? <p>{props.message}</p> : props.message}
          <ReAuthenticateUser formRef={formRef} runPasswordValidation={props.runPasswordValidation} />
          <ButtonGroup>
            {handleClose && !props.hideSecondaryButton && (
              <Button.Neutral
                label={props.secondaryButtonText || copies.get("no")}
                variant={secondaryButtonVariant}
                isOutline={secondaryButtonIsOutlined}
                onClick={handleClose}
              />
            )}
            {handleConfirm && (
              <Button
                label={props.primaryButtonText || copies.get("yes")}
                variant={primaryButtonVariant}
                onClick={onConfirmHandler}
                isOutline={primaryButtonIsOutlined}
              />
            )}
          </ButtonGroup>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default AuthenticationAlertModal;
